export default __webpack_public_path__ + "src/assets/support-us.06332ea9ec4c8e7d0c224add2c111514.svg";